import script from "./Caution.vue?vue&type=script&lang=ts&setup=true"
export * from "./Caution.vue?vue&type=script&lang=ts&setup=true"

import "./Caution.vue?vue&type=style&index=0&id=66111b90&scoped=true&lang=css"

import exportComponent from "/data/jenkins/workspace/jet/cbt/production/deploy-cbt/exam/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66111b90"]])

export default __exports__